import { IPublicClientApplication } from '@azure/msal-browser'
import axios from 'axios'
import { protectedResources } from '../authConfig'
import { OnboardingOrganization } from '../models/Onboarding/OnboardingOrganization'
import { OnboardingState } from '../models/Onboarding/OnboardingState'
import { Organization } from '../models/Organization'
import { TransactionSummary } from '../models/Transactions/TransactionSummary'
import {
  authorizedGet,
  authorizedPatch,
  authorizedPost,
} from '../utils/authUtils'

export const fetchOnboardingState = async (
  organizationId: number,
  instance: IPublicClientApplication,
): Promise<OnboardingState> => {
  const baseUrl = process.env.REACT_APP_BASE_API_URL
  return await authorizedGet(
    instance,
    `${baseUrl}/organizations/${organizationId}/onboarding`,
    protectedResources.scopes.read,
  )
}

export const fetchOnboardingOrganizationById = async (
  id: number,
  instance: IPublicClientApplication,
): Promise<OnboardingOrganization> => {
  const baseUrl = process.env.REACT_APP_BASE_API_URL
  return await authorizedGet(
    instance,
    `${baseUrl}/organizations/${id}`,
    protectedResources.scopes.read,
  )
}

export const fetchOrganizationById = async (
  id: number,
  instance: IPublicClientApplication,
): Promise<Organization> => {
  const baseUrl = process.env.REACT_APP_BASE_API_URL
  return await authorizedGet(
    instance,
    `${baseUrl}/organizations/${id}`,
    protectedResources.scopes.read,
  )
}

export const fetchMyOrganization = async (
  instance: IPublicClientApplication,
): Promise<OnboardingOrganization> => {
  const baseUrl = process.env.REACT_APP_BASE_API_URL
  return await authorizedGet(
    instance,
    `${baseUrl}/organizations/me`,
    protectedResources.scopes.read,
  )
}

export const initializeOnboardingState = async (
  organizationId: number,
  instance: IPublicClientApplication,
): Promise<OnboardingState> => {
  const baseUrl = process.env.REACT_APP_BASE_API_URL
  return await authorizedPost(
    instance,
    `${baseUrl}/organizations/${organizationId}/onboarding`,
    {},
    protectedResources.scopes.read,
  )
}

export const setOnboardingStateToComplete = async (
  organizationId: number,
  instance: IPublicClientApplication,
): Promise<OnboardingState> => {
  const baseUrl = process.env.REACT_APP_BASE_API_URL
  return await authorizedPatch(
    instance,
    `${baseUrl}/organizations/${organizationId}/onboarding/complete`,
    {},
    protectedResources.scopes.read,
  )
}

export const updateOrganization = async (
  organization: Partial<OnboardingOrganization>,
  instance: IPublicClientApplication,
): Promise<OnboardingOrganization> => {
  const baseUrl = process.env.REACT_APP_BASE_API_URL
  return await authorizedPatch(
    instance,
    `${baseUrl}/organizations/${organization.id}`,
    organization,
    protectedResources.scopes.read,
  )
}

export const fetchOrganizationsByIds = async (
  ids: number[],
): Promise<Organization[]> => {
  const baseUrl = process.env.REACT_APP_BASE_API_URL
  const response = await axios.get<Organization[]>(
    `${baseUrl}/organizations?organizationIds=${ids.join(',')}`,
  )
  return response.data
}

export const fetchOrganizationTransactions = async (
  organizationId: number,
  instance: IPublicClientApplication,
): Promise<TransactionSummary[]> => {
  const baseUrl = process.env.REACT_APP_BASE_API_URL
  return await authorizedGet(
    instance,
    `${baseUrl}/organizations/${organizationId}/transactions`,
    protectedResources.scopes.read,
  )
}

export const fetchOrganizationTransactionDetails = async (
  organizationId: number,
  transactionId: string,
  instance: IPublicClientApplication,
): Promise<TransactionSummary> => {
  const baseUrl = process.env.REACT_APP_BASE_API_URL
  return await authorizedGet(
    instance,
    `${baseUrl}/organizations/${organizationId}/transactions/${transactionId}`,
    protectedResources.scopes.read,
  )
}

export const setStripeOnboardingComplete = async (
  organizationId: number,
  instance: IPublicClientApplication,
): Promise<OnboardingState> => {
  const baseUrl = process.env.REACT_APP_BASE_API_URL
  return await authorizedPatch(
    instance,
    `${baseUrl}/organizations/${organizationId}/onboarding/stripeOnboardingComplete`,
    {},
    protectedResources.scopes.read,
  )
}
